import React, { useState, useEffect } from 'react'
import { Link } from 'react-scroll'
import { motion, AnimatePresence } from 'framer-motion'
import { HiMenuAlt3, HiX } from 'react-icons/hi'
import logo from '../assets/logo.png'

export default function MYNavbar() {
    const [isScrolled, setIsScrolled] = useState(false)
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20)
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const navLinks = [
        { to: 'about', label: 'About Us' },
        { to: 'products', label: 'Products' },
        { to: 'contact', label: 'Contact Us' },
    ]

    return (
        <motion.nav
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.3 }}
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                isScrolled
                    ? 'bg-white/95 backdrop-blur-md shadow-md'
                    : 'bg-white/80 backdrop-blur-sm'
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    {/* Logo */}
                    <Link
                        to="home"
                        spy={true}
                        smooth={true}
                        offset={-100}
                        duration={500}
                        className="cursor-pointer"
                    >
                        <motion.div
                            whileHover={{ scale: 1.02 }}
                            className="flex items-center gap-3"
                        >
                            <img 
                                src={logo} 
                                alt="Alivany Medical & Dental Supplies" 
                                className="h-12 w-auto object-contain"
                            />
                            <div className="flex flex-col">
                                <span className="text-2xl font-bold text-medical-blue-700 tracking-tight">
                                    Alivany Medical
                                </span>
                                <span className="text-base md:text-lg font-medium text-medical-teal-600 -mt-1">
                                    & Dental Supplies
                                </span>
                            </div>
                        </motion.div>
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-8">
                        {navLinks.map((link) => (
                            <Link
                                key={link.to}
                                to={link.to}
                                spy={true}
                                smooth={true}
                                offset={link.to === 'products' ? -120 : -100}
                                duration={500}
                                className="text-gray-700 hover:text-medical-blue-600 font-medium transition-colors duration-200 cursor-pointer relative group"
                            >
                                {link.label}
                                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-medical-blue-600 transition-all duration-300 group-hover:w-full"></span>
                            </Link>
                        ))}
                        <Link
                            to="contact"
                            spy={true}
                            smooth={true}
                            offset={-100}
                            duration={500}
                            className="ml-4 px-6 py-2.5 bg-medical-blue-600 text-white font-semibold rounded-lg hover:bg-medical-blue-700 transition-all duration-200 shadow-md hover:shadow-lg cursor-pointer"
                        >
                            Request Quote
                        </Link>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                        aria-label="Toggle menu"
                    >
                        {isMobileMenuOpen ? (
                            <HiX className="w-6 h-6" />
                        ) : (
                            <HiMenuAlt3 className="w-6 h-6" />
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            <AnimatePresence>
                {isMobileMenuOpen && (
                        <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.2 }}
                            className="md:hidden bg-medical-blue-600 border-t border-medical-blue-500"
                        >
                            <div className="px-4 py-6 space-y-4">
                                {navLinks.map((link) => (
                                    <Link
                                        key={link.to}
                                        to={link.to}
                                        spy={true}
                                        smooth={true}
                                        offset={link.to === 'products' ? -120 : -100}
                                        duration={500}
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className="block text-white hover:text-medical-teal-200 font-medium py-2 transition-colors cursor-pointer text-center"
                                    >
                                        {link.label}
                                    </Link>
                                ))}
                                <Link
                                    to="contact"
                                    spy={true}
                                    smooth={true}
                                    offset={-100}
                                    duration={500}
                                    onClick={() => setIsMobileMenuOpen(false)}
                                    className="block mt-4 px-6 py-3 bg-white text-medical-blue-600 font-semibold rounded-lg hover:bg-medical-teal-50 transition-all text-center cursor-pointer mx-auto max-w-xs"
                                >
                                    Request Quote
                                </Link>
        </div>
                        </motion.div>
                )}
            </AnimatePresence>
        </motion.nav>
    )
}
